(function () {
  document.documentElement.classList.add('js');

  var anchorTargets = {
    '#shop': '#shop .section-heading',
    '#ueber-uns': '#ueber-uns .home-about__copy',
    '#blog': '#blog .section-heading',
    '#kontakt': '#kontakt .cta-band__inner'
  };

  function getHeaderOffset() {
    var header = document.querySelector('.site-header');
    return header ? header.getBoundingClientRect().height + 18 : 18;
  }

  function scrollToAnchor(hash, behavior) {
    var selector = anchorTargets[hash] || hash;
    var target = document.querySelector(selector);

    if (!target) {
      return;
    }

    var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: behavior || 'smooth'
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');

    if (!link || !link.hash || !anchorTargets[link.hash]) {
      return;
    }

    event.preventDefault();
    history.pushState(null, '', link.hash);
    scrollToAnchor(link.hash, 'smooth');
  });

  window.addEventListener('load', function () {
    if (window.location.hash && anchorTargets[window.location.hash]) {
      window.setTimeout(function () {
        scrollToAnchor(window.location.hash, 'auto');
      }, 0);
    }
  });
})();
